import React from 'react';

type Props = {
    mode?: '' | 'filter' | 'sort' | 'manage',
    onFilter?: () => void,
    onSort?: () => void,
    onManage?: () => void,
};

export default function CourtsFilterCard({ mode, onFilter, onSort, onManage }: Props) {
    return (
        <div
            style={{
                padding: '0 30px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                height: '100%',
            }}
        >
            <div
                style={{
                    border: '1px solid #072C4D',
                    borderRadius: '7px',
                    padding: '8px',
                    marginBottom: 6,
                    textAlign: 'left',
                    backgroundColor: '#ffffff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-around',
                    opacity: !mode || mode === 'filter' ? 1 : 0.25,
                    cursor: !mode || mode === 'filter' ? 'pointer' : undefined,
                }}
                onClick={onFilter}
                role="presentation"
            >
                <span style={{ width: '45%', fontSize: 12 }}>Filter</span>
                <img
                    src={require('../../../../assets/icons/filters/1.png').default}
                    width="16"
                    alt=""
                />
            </div>

            <div
                style={{
                    border: '1px solid #072C4D',
                    borderRadius: '7px',
                    padding: '8px',
                    marginBottom: 6,
                    textAlign: 'left',
                    backgroundColor: '#ffffff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-around',
                    opacity: !mode || mode === 'sort' ? 1 : 0.25,
                    cursor: !mode || mode === 'sort' ? 'pointer' : undefined,
                }}
                onClick={onSort}
                role="presentation"
            >
                <span style={{ width: '45%', fontSize: 12 }}>Sort</span>
                <img
                    src={require('../../../../assets/icons/filters/2.png').default}
                    width="16"
                    alt=""
                />
            </div>

            <div
                style={{
                    border: '1px solid #072C4D',
                    borderRadius: '7px',
                    padding: '8px',
                    textAlign: 'left',
                    backgroundColor: '#ffffff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-around',
                    opacity: !mode || mode === 'manage' ? 1 : 0.25,
                    cursor: !mode || mode === 'manage' ? 'pointer' : undefined,
                }}
                onClick={onManage}
                role="presentation"
            >
                <span style={{ width: '45%', fontSize: 12 }}>Manage</span>
                <img
                    src={require('../../../../assets/icons/filters/3.png').default}
                    width="16"
                    alt=""
                />
            </div>
        </div>
    );
}
